export function formatMoney(value, cents, separator, dot, includeSpace = true) {
    if (!value){
        return false;
    }
    cents = Math.abs(cents)
    cents = isNaN(cents) ? 2 : cents
    separator = separator === undefined ? "." : separator
    dot = dot === undefined ? "," : dot
    let s = value < 0 ? "-" : "$"
    s = (includeSpace && value > 0) ? s + " " : s;
    let i = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(cents),10))
    let j = i.length
    j = j > 3 ? j % 3 : 0
    return s + (j ? i.substr(0, j) + dot : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + dot) + (cents ? separator + Math.abs(value - i).toFixed(cents).slice(2) : "");
 };

 export function getErrorsApiToReduxForm(errors){
    let apiErrors = errors;
    let fields = Object.keys(errors);
    let reduxFormErrorFormat = {};
    fields.forEach((field) => {
        reduxFormErrorFormat[field] = '';
        apiErrors[field].forEach((description)=> {
            reduxFormErrorFormat[field] = reduxFormErrorFormat[field] + ' ' + description;
        });
    });
    return reduxFormErrorFormat;
 };

 export function getQueryString(mkt_params){
    let mkt_params_keys = Object.keys(mkt_params);
    let queryString = '?';
    mkt_params_keys.forEach((mkt_params_key, index) => {
        //if (checkIfParamExist(mkt_params_key)){
        if(index !== 0){
            queryString = queryString.concat('&');
        }
        queryString = queryString.concat(mkt_params_key + '=' + mkt_params[mkt_params_key] + '');
        //}
    });
    return queryString;
 };

 export function sanetizeMktParams(mktParamsObject){
    let mktParamsSanetizedObject = {};
    Object.keys(mktParamsObject).map(function(key, index) {
        if (checkIfParamExist(key)){
            mktParamsSanetizedObject[key] = mktParamsObject[key];
        }
        return mktParamsSanetizedObject[key]
    });
    return mktParamsSanetizedObject;
 }

 function checkIfParamExist(param){
    let allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_provider', 'cid'];
    for (var allowedParam of allowedParams){
        if (allowedParam === param){
            return true;
        }
    };
    return false;
 }

 export function minToSize(width){
    return (window.innerWidth <= width)
 }

export let styles = {
    item: {
        padding: '2px 6px',
        cursor: 'default'
    },
    highlightedItem: {
        color: 'white',
        background: 'hsl(200, 50%, 50%)',
        padding: '2px 6px',
        cursor: 'default'
    },
    menu: {
        border: 'solid 1px #ccc'
    }
}

export function* range(start, end) {
    for (let i = start; i <= end; i++) {
        yield i;
    }
}

export function getMiddleIndexValue(list) {
    return Math.round((list.length - 1) / 2)
}

export function getRandomNumber(max, min, integer){
    let random = Math.random() * (+max - +min) + +min;
    return integer && Math.floor(random) || random;
}

//algorithm Fisher-Yates
export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function getMaxMinAmountValue(amounts, type) {
    const amountkeys = Object.keys(amounts);
    const amountValues = amountkeys.map((amount)=>{return Number(amount)})
    const amount = type === "max" ? Math.max(...amountValues) : Math.min(...amountValues)
    return amount
}

export function objectToArrayKeepObject(obj) {

    var result = [];
    var keys = Object.keys(obj);

    for(var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = obj[key];
          result.push({[key]: value});
    }
    return result;
}

export function resizeImage(originalWidth, originalHeight, widthMax, heightMax){
    let resizedImage = {
        width: originalWidth,
        height: originalHeight
    }

    if (originalWidth > widthMax || originalHeight > heightMax ){
        resizedImage = {
            width: widthMax,
            height: heightMax
        }
        const aspectRatio = originalWidth / originalHeight;

        if(originalWidth > originalHeight){
            resizedImage.height = widthMax / aspectRatio;
        } else {
            resizedImage.width = heightMax * aspectRatio;
        }
    }

    return resizedImage;
}


/** WEBPACK FOOTER **
 ** ./src/utils/utils.js
 **/